import { assignInlineVars } from "@vanilla-extract/dynamic";
import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { BaseSpacingValue, vars } from "web/react/emo/theme.css";
import * as styles from "./verified-badge.css";

interface VerifiedBadgeProps {
    size?: BaseSpacingValue;
    className?: string;
}
export function VerifiedBadge({ size = "xs", className }: VerifiedBadgeProps): React.ReactElement {
    return (
        <SVGIcon
            dataTestId="verified-badge"
            style={assignInlineVars({ [styles.size]: vars.spacing[size] })}
            className={clsx(styles.badge, className)}
            name="verified"
        />
    );
}
